module.exports = __webpack_public_path__ + "static/media/xls.2b6bd56f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/xls.svg
// module id = 120
// module chunks = 0